import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PaginationAdvanced from "../../components/PaginationAdvanced";
import { CSSTransitionGroup } from 'react-transition-group';
import moment from "moment";
import Search from "../../components/Search";
import _ from "lodash";

import Index from "../Index";
import { fetchSentEmails } from "../../actions/index";

export class AdminSentEmailsIndex extends Index {
  static propTypes = {
    fetchSentEmails: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    sentEmails: PropTypes.object,
    emails: PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchSentEmails(
      this.serialize(newQueries)
    );
    this.props.history.push(`/admin/sent_emails${this.serialize(newQueries)}`);
  }

  renderSentEmails() {
    let query = new URLSearchParams(this.props.location.search);
    if (!this.props.emails.data) {
      return (
        <tr>
          <td colSpan={15}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              />
            </div>
          </td>
        </tr>
      );
    } else if (query.get('search').length == 0) {
      return (
        <tr>
          <td colSpan={15}>
            <div className="well well-lg text-center">
              Enter a complete email address to search.&nbsp;
            </div>
          </td>
        </tr>
      );
    } else if (this.props.emails.data.length == 0) {
      return (
        <tr>
          <td colSpan={15}>
            <div className="well well-lg text-center">
              No sent emails found.&nbsp;
            </div>
          </td>
        </tr>
      );
    }

    return this.props.emails.data.map(email => {
      return (
        <tr key={email.id}>
          <td>{moment(email.created_at).format("MM/DD/YYYY h:mm:ss A")}</td>
          <td>{email.from}</td>
          <td>{email.to}</td>
          <td>{email.subject}</td>
          <td className="text-right">{email.delivered_count}</td>
          <td className="text-right">{email.opened_count}</td>
          <td className="text-right">{email.clicked_count}</td>
          <td className="text-right">{email.unsubscribed_count}</td>
          <td className="text-right">{email.complained_count}</td>
          <td className="text-right">{email.bounced_count}</td>
          <td className="text-right">{email.dropped_count}</td>
          <td className="text-right">{email.lead_id}</td>
          <td className="text-right">{email.company_id}</td>
          <td>{email.emailable_type}</td>
          <td className="text-right">{email.emailable_id}</td>
          <td className="text-right">
            <Link
              to={`/sent_emails/${ email.id }`}
              className="btn btn-xs btn-inverse pull-right"
            >
              Details
            </Link>
          </td>
        </tr>
      );
    });
  }

  render() {
    let count = 0;
    if (this.props.emails.meta) {
      count = this.props.emails.meta.count;
    }
    return (
      <div className="sentEmails_index">
        <div className="row">
          <h1>
            Sent Emails
            <div className="pull-right">
              <Search
                handleSearch={this.handleSearch.bind(this)}
                params={this.props.params}
              />
            </div>
          </h1>
        </div>
        <div className="row">
          <table className="table table-striped">
            <thead>
              <tr>
                <th
                  className={`email_date ${this.indicateSorting("created_at")}`}
                  data-sort="created_at"
                  onClick={this.handleOrder.bind(this)}
                >
                  Sent Date
                </th>
                <th
                  className={`email_from ${this.indicateSorting(
                    "sent_emails.from"
                  )}`}
                  data-sort="sent_emails.from"
                  onClick={this.handleOrder.bind(this)}
                >
                  From
                </th>
                <th
                  className={`email_to ${this.indicateSorting(
                    "sent_emails.to"
                  )}`}
                  data-sort="sent_emails.to"
                  onClick={this.handleOrder.bind(this)}
                >
                  To
                </th>
                <th
                  className={`email_subject ${this.indicateSorting("subject")}`}
                  data-sort="subject"
                  onClick={this.handleOrder.bind(this)}
                >
                  Subject
                </th>
                <th
                  className={`text-right email_stats_sent ${this.indicateSorting(
                    "delivered_count"
                  )}`}
                  data-sort="delivered_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Sent
                </th>
                <th
                  className={`text-right email_stats_opened ${this.indicateSorting(
                    "opened_count"
                  )}`}
                  data-sort="opened_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Opens
                </th>
                <th
                  className={`text-right email_stats_clicked ${this.indicateSorting(
                    "clicked_count"
                  )}`}
                  data-sort="clicked_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Clicks
                </th>
                <th
                  className={`text-right email_stats_unsubscribed ${this.indicateSorting(
                    "unsubscribed_count"
                  )}`}
                  data-sort="unsubscribed_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Unsubs
                </th>
                <th
                  className={`text-right email_stats_spam_report ${this.indicateSorting(
                    "complained_count"
                  )}`}
                  data-sort="complained_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Spam R.
                </th>
                <th
                  className={`text-right email_stats_bounced ${this.indicateSorting(
                    "bounced_count"
                  )}`}
                  data-sort="bounced_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Bounces
                </th>
                <th
                  className={`text-right email_stats_failed ${this.indicateSorting(
                    "dropped_count"
                  )}`}
                  data-sort="dropped_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Failures
                </th>
                <th className={`text-right email_lead_id`} data-sort="lead_id">
                  Lead ID
                </th>
                <th
                  className={`text-right email_company_id`}
                  data-sort="company_id"
                >
                  Company ID
                </th>
                <th
                  className={`text-right email_emailable_type ${this.indicateSorting(
                    "emailable_type"
                  )}`}
                  data-sort="emailable_type"
                  onClick={this.handleOrder.bind(this)}
                >
                  Emailable Type
                </th>
                <th
                  className={`text-right email_emailable_id ${this.indicateSorting(
                    "emailable_id"
                  )}`}
                  data-sort="emailable_id"
                  onClick={this.handleOrder.bind(this)}
                >
                  Emailable ID
                </th>
              </tr>
            </thead>
            <tbody>{this.renderSentEmails()}</tbody>
          </table>
        </div>
        <div className="row text-right">
          <PaginationAdvanced
            handle={this.handlePagination.bind(this)}
            total={count}
            page={this.state.page}
            per_page={this.state.per_page}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { emails: state.sentEmails.all };
}

export default connect(
  mapStateToProps,
  { fetchSentEmails }
)(AdminSentEmailsIndex);
